import template from './building-status-type.jade';
import { filterItems } from '../../filter-items';
import allItems, {itemsByCategory} from '../../../enums/building-status-type';

export default angular
    .module('cian.addForm.buildingStatusType', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutBuildingBuildingStatusType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'categoryService', 'adStateService', function($scope, categoryService, adStateService) {
            $scope.$watch(() => this.ad.category, category => {
                if (!category) return;
                const { objectType } = categoryService.getInfoByCategory(category);

                const categoryConfig = itemsByCategory[objectType] || itemsByCategory.default;
                this.items = filterItems(allItems, 'value', categoryConfig.items);

                // при смене категории - ставим значение по умолчанию
                if (adStateService.categoryChanged) {
                    this.ad.building.statusType = categoryConfig.defaultValue;
                }
            });
        }],
        controllerAs: 'buildingStatusType',
        template,
    }))
    .name;
